import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

const categoryIcons: Record<string, string> = {
  'wanghong-fancha': 'ri-user-search-line',
  'mingxing-tafang': 'ri-building-2-line',
  'meiri-dasai': 'ri-trophy-line',
  'dujia-shoufa': 'ri-vip-crown-line',
};

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 py-10 md:py-14 px-4 md:px-8 lg:px-12">
      <div className="mb-8 md:mb-10">
        <p className="text-sm text-foreground-600 mb-2">{t('categoriesLabel')}</p>
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
          {t('categoriesTitle')}
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 p-5 md:p-6 rounded-lg hover:bg-background-200/50 transition-colors cursor-pointer"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full border border-primary-500/30 text-primary-500 mb-4">
              <i className={`${categoryIcons[cat.slug]} text-lg md:text-xl`} />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
              {cat.name}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
            <div className="mt-3 flex items-center gap-1 text-xs text-primary-500">
              <span>{cat.articleCount} 篇爆料</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}